export type LaptopFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type LaptopFilterGroup = {
  id: string;
  label: string;
  options: LaptopFilterOption[];
};

export const laptopFilterGroups: LaptopFilterGroup[] = [
  {
    id: 'need',
    label: 'Laptop theo nhu cầu',
    options: [
      {
        value: 'laptop-gaming',
        label: 'Laptop Gaming',
        keywords: ['laptop gaming', 'gaming'],
      },
      {
        value: 'laptop-van-phong',
        label: 'Laptop văn phòng',
        keywords: ['laptop văn phòng', 'laptop van phong', 'van phong', 'văn phòng', 'office'],
      },
      { value: 'laptop-ai', label: 'Laptop AI', keywords: ['laptop ai', 'ai'] },
    ],
  },
  {
    id: 'acer',
    label: 'Laptop ACER',
    options: [
      { value: 'nitro-propanel', label: 'NITRO PROPANEL', keywords: ['nitro propanel'] },
      { value: 'predator', label: 'PREDATOR', keywords: ['predator'] },
      { value: 'aspire', label: 'ASPIRE', keywords: ['aspire'] },
      { value: 'nitro', label: 'NITRO', keywords: ['nitro'] },
      { value: 'swift', label: 'SWIFT', keywords: ['swift'] },
    ],
  },
  {
    id: 'msi',
    label: 'Laptop MSI',
    options: [
      { value: 'modern', label: 'MODERN', keywords: ['modern'] },
      { value: 'thin-cyborg', label: 'Thin/Cyborg', keywords: ['thin', 'cyborg'] },
      { value: 'katana', label: 'KATANA', keywords: ['katana'] },
      { value: 'crosshair', label: 'Crosshair', keywords: ['crosshair'] },
      { value: 'vector', label: 'Vector', keywords: ['vector'] },
    ],
  },
  {
    id: 'lenovo',
    label: 'Laptop LENOVO',
    options: [
      { value: 'legion', label: 'LEGION', keywords: ['legion'] },
      { value: 'loq', label: 'LOQ', keywords: ['loq'] },
      {
        value: 'thinkpad-thinkbook',
        label: 'Thinkpad / Thinkbook',
        keywords: ['thinkpad', 'thinkbook'],
      },
      { value: 'ideapad', label: 'IDEAPAD', keywords: ['ideapad'] },
      { value: 'yoga', label: 'YOGA', keywords: ['yoga'] },
    ],
  },
  {
    id: 'hp',
    label: 'Laptop HP',
    options: [
      { value: 'hp-14-15', label: 'HP 14 / HP 15', keywords: ['hp 14', 'hp 15'] },
      { value: 'pavilion', label: 'Pavilion', keywords: ['pavilion'] },
      { value: 'victus-omen', label: 'VICTUS / OMEN', keywords: ['victus', 'omen'] },
      { value: 'probook', label: 'Probook', keywords: ['probook'] },
      { value: 'envy', label: 'ENVY', keywords: ['envy'] },
    ],
  },
  {
    id: 'asus',
    label: 'Laptop ASUS',
    options: [
      { value: 'expertbook', label: 'EXPERTBOOK', keywords: ['expertbook'] },
      { value: 'vivobook', label: 'VIVOBOOK', keywords: ['vivobook'] },
      { value: 'rog-series', label: 'ROG Series', keywords: ['rog'] },
      { value: 'tuf-series', label: 'TUF Series', keywords: ['tuf'] },
    ],
  },
  {
    id: 'gigabyte',
    label: 'Laptop GIGABYTE',
    options: [
      { value: 'aorus', label: 'AORUS', keywords: ['aorus'] },
      { value: 'g5-g7', label: 'G5 / G7 Series', keywords: ['g5', 'g7'] },
    ],
  },
  {
    id: 'dell',
    label: 'Laptop DELL',
    options: [
      { value: 'vostro', label: 'VOSTRO', keywords: ['vostro'] },
      { value: 'inspiron', label: 'INSPIRON', keywords: ['inspiron'] },
    ],
  },
  {
    id: 'other',
    label: 'Laptop khác',
    options: [
      { value: 'laptop-intel', label: 'Laptop Intel', keywords: ['laptop intel', 'intel'] },
      { value: 'laptop-fujitsu', label: 'Laptop Fujitsu', keywords: ['fujitsu'] },
      { value: 'laptop-huawei', label: 'Laptop Huawei', keywords: ['huawei'] },
      { value: 'laptop-lg', label: 'Laptop LG', keywords: ['lg'] },
      {
        value: 'laptop-trung-bay',
        label: 'Laptop trưng bày',
        keywords: ['trưng bày', 'trung bay'],
      },
      { value: 'laptop-core-i3', label: 'Laptop Core i3', keywords: ['core i3', 'i3'] },
      { value: 'laptop-core-i5', label: 'Laptop Core i5', keywords: ['core i5', 'i5'] },
    ],
  },
  {
    id: 'gpu',
    label: 'Laptop theo VGA',
    options: [
      { value: 'gtx-1650', label: 'GTX 1650 / 1650Ti', keywords: ['1650', '1650ti'] },
      { value: 'rtx-40', label: 'RTX 40 Series', keywords: ['rtx 40'] },
      { value: 'rtx-3050', label: 'RTX 3050 / 3050Ti', keywords: ['rtx 3050', '3050'] },
      { value: 'rtx-3060', label: 'RTX 3060', keywords: ['rtx 3060', '3060'] },
      { value: 'rtx-3070', label: 'RTX 3070 / 3070Ti', keywords: ['rtx 3070', '3070'] },
      { value: 'rtx-3080', label: 'RTX 3080 / 3080Ti', keywords: ['rtx 3080', '3080'] },
      { value: 'vga-amd', label: 'VGA AMD', keywords: ['vga amd', 'radeon', 'amd'] },
    ],
  },
];
